/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesPlayGameResponseLaunchDataOptions, FxIdWebFeaturesPlayGameResponseLaunchDataOptionsFromJSONTyped, FxIdWebFeaturesPlayGameResponseLaunchDataOptionsToJSON, } from './FxIdWebFeaturesPlayGameResponseLaunchDataOptions';
export function FxIdWebFeaturesPlayGameResponseLaunchDataFromJSON(json) {
    return FxIdWebFeaturesPlayGameResponseLaunchDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseLaunchDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesPlayGameResponseLaunchDataOptions(json)) {
        return FxIdWebFeaturesPlayGameResponseLaunchDataOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesPlayGameResponseLaunchDataToJSON(json) {
    return FxIdWebFeaturesPlayGameResponseLaunchDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseLaunchDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesPlayGameResponseLaunchDataOptions(value)) {
        return FxIdWebFeaturesPlayGameResponseLaunchDataOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameResponseLaunchData.js.map